(function () {
  var OKENDO_BASE = "https://api.okendo.io/v1/stores/";
  var MAX_FETCH_PAGES = 5;

  function escapeHtml(text) {
    var el = document.createElement("span");
    el.textContent = text || "";
    return el.innerHTML;
  }

  function formatRelativeDate(dateString) {
    if (!dateString) return "";

    var date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    var now = new Date();
    var diffMs = now.getTime() - date.getTime();
    var diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays < 1) return "Today";
    if (diffDays === 1) return "1 day ago";
    if (diffDays < 30) return diffDays + " days ago";

    var diffMonths = Math.floor(diffDays / 30);
    if (diffMonths === 1) return "1 month ago";
    if (diffMonths < 12) return diffMonths + " months ago";

    var diffYears = Math.floor(diffMonths / 12);
    return diffYears === 1 ? "1 year ago" : diffYears + " years ago";
  }

  function hasReviewMedia(review) {
    if (!review.media || !review.media.length) return false;
    var productImg = (review.productImageUrl || "").replace(/\?.*$/, "");
    return review.media.some(function (item) {
      var url = item.fullSizeUrl || item.largeUrl || item.thumbnailUrl || "";
      if (!url) return false;
      var clean = url.replace(/\?.*$/, "");
      return clean !== productImg;
    });
  }

  function getReviewMedia(review) {
    if (hasReviewMedia(review)) {
      var item = review.media[0];
      return item.fullSizeUrl || item.largeUrl || item.thumbnailUrl || "";
    }

    return review.productImageUrl || "";
  }

  function getReviewerName(review) {
    if (!review.reviewer) return "Customer";
    return review.reviewer.displayName || review.reviewer.name || "Customer";
  }

  function matchesMediaFilter(review, mediaFilter) {
    if (mediaFilter === "with_media") return hasReviewMedia(review);
    if (mediaFilter === "without_media") return !hasReviewMedia(review);
    return true;
  }

  function matchesRatingFilter(review, ratingFilter) {
    var rating = Number(review.rating) || 0;
    if (ratingFilter === "all") return true;
    if (ratingFilter === "5") return rating === 5;
    var minRating = parseInt(ratingFilter, 10);
    if (isNaN(minRating)) return true;
    return rating >= minRating;
  }

  function filterReviews(reviews, mediaFilter, ratingFilter) {
    return reviews.filter(function (review) {
      return matchesMediaFilter(review, mediaFilter) && matchesRatingFilter(review, ratingFilter);
    });
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'AUD';
    var locale = window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en-AU';
    var formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format((cents || 0) / 100);
    return formatted.replace('A$', '$').replace('AU$', '$');
  }

  // ─── Standard review slide ───
  function renderSlide(review, starsSrc, placeholderSrc) {
    var mediaUrl = getReviewMedia(review) || placeholderSrc || "";
    var title = review.title || "";
    var body = review.body || "";
    var rating = Number(review.rating) || 5;
    var author = getReviewerName(review);
    var dateLabel = formatRelativeDate(review.dateCreated);

    var mediaHtml = mediaUrl
      ? '<img src="' + escapeHtml(mediaUrl) + '" alt="" loading="lazy" />'
      : "";

    return (
      '<article class="reviews__card swiper-slide">' +
        '<div class="reviews__card-main">' +
          '<div class="reviews__media">' + mediaHtml + "</div>" +
          '<div class="reviews__body">' +
            '<div class="reviews__content">' +
              '<div class="reviews__content-main">' +
                '<img class="reviews__stars" src="' + escapeHtml(starsSrc) + '" alt="' + rating + ' stars" width="146" height="26" />' +
                '<div class="reviews__text-row">' +
                  '<div class="reviews__scroll-area" data-reviews-scroll>' +
                    (title ? '<h3 class="reviews__review-title">' + escapeHtml(title) + "</h3>" : "") +
                    (body ? '<p class="reviews__review-text">' + escapeHtml(body) + "</p>" : "") +
                  "</div>" +
                  '<div class="reviews__scroll" aria-hidden="true"><span data-reviews-scroll-thumb></span></div>' +
                "</div>" +
              "</div>" +
            "</div>" +
            '<div class="reviews__divider" aria-hidden="true"></div>' +
            '<div class="reviews__meta">' +
              '<p class="reviews__author">' + escapeHtml(author) + "</p>" +
              (dateLabel ? '<p class="reviews__date">' + escapeHtml(dateLabel) + "</p>" : "") +
            "</div>" +
          "</div>" +
        "</div>" +
      "</article>"
    );
  }

  // ─── Popular review slide ───
  function renderPopularSlide(review, starsSrc, cartIconSrc, productData, placeholderSrc) {
    var productName = (productData && productData.title) || review.productName || review.product || "";
    var mediaSrc = getReviewMedia(review) || placeholderSrc || "";
    var isPlaceholder = !getReviewMedia(review) && !!placeholderSrc;
    var productPrice = productData && productData.price ? formatMoney(productData.price) : "";
    var productUrl = (productData && productData.url) || "";
    var hasProductLink = !!productUrl;
    var variantId = (productData && productData.variantId) || "";
    var body = review.body || "";
    var rating = Number(review.rating) || 5;
    var author = getReviewerName(review);
    var dateLabel = formatRelativeDate(review.dateCreated);

    var mediaClass = "reviews__product-media" + (isPlaceholder ? " reviews__product-media--placeholder" : "");
    var mediaTag = hasProductLink ? "a" : "div";
    var mediaAttrs = hasProductLink
      ? ' class="' + mediaClass + '" href="' + escapeHtml(productUrl) + '"'
      : ' class="' + mediaClass + '"';
    var nameHtml = hasProductLink
      ? '<a class="reviews__product-name" href="' + escapeHtml(productUrl) + '">' + escapeHtml(productName) + "</a>"
      : '<span class="reviews__product-name">' + escapeHtml(productName) + "</span>";

    return (
      '<article class="reviews__card swiper-slide">' +
        '<div class="reviews__product">' +
          "<" + mediaTag + mediaAttrs + ">" +
            (mediaSrc ? '<img src="' + escapeHtml(mediaSrc) + '" alt="" width="70" height="70" loading="lazy" />' : "") +
          "</" + mediaTag + ">" +
          '<div class="reviews__product-info">' +
            nameHtml +
            '<div class="reviews__product-row">' +
              (productPrice ? '<span class="reviews__product-price">' + productPrice + "</span>" : "") +
              (variantId
                ? '<button class="reviews__product-cart" type="button" aria-label="Add to cart" data-variant-id="' + variantId + '">' +
                    '<img src="' + escapeHtml(cartIconSrc) + '" alt="" width="17" height="17" />' +
                  "</button>"
                : "") +
            "</div>" +
          "</div>" +
        "</div>" +
        '<div class="reviews__divider" aria-hidden="true"></div>' +
        '<div class="reviews__popular-body" data-review-expand>' +
          '<div class="reviews__popular-content" data-review-expand-content>' +
            '<div class="reviews__popular-head">' +
              '<p class="reviews__author">' + escapeHtml(author) + "</p>" +
              '<div class="reviews__popular-meta">' +
                '<img class="reviews__stars reviews__stars--sm" src="' + escapeHtml(starsSrc) + '" alt="' + rating + ' stars" width="78" height="14" />' +
                (dateLabel ? '<p class="reviews__date">' + escapeHtml(dateLabel) + "</p>" : "") +
              "</div>" +
            "</div>" +
            (body ? '<p class="reviews__popular-text">' + escapeHtml(body) + "</p>" : "") +
          "</div>" +
          '<button class="reviews__show-more" type="button" data-review-expand-toggle aria-expanded="false">Show more</button>' +
        "</div>" +
      "</article>"
    );
  }

  // ─── Fetch product data from Shopify ───
  function fetchProductData(handle) {
    return fetch("/products/" + encodeURIComponent(handle) + ".js")
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (product) {
        if (!product) return null;
        var variant = product.variants && product.variants[0];
        return {
          title: product.title,
          url: "/products/" + product.handle,
          image: product.featured_image || (product.images && product.images[0]) || "",
          price: variant ? variant.price : product.price,
          variantId: variant ? variant.id : ""
        };
      })
      .catch(function () { return null; });
  }

  function fetchAllProductData(reviews) {
    var handles = {};
    reviews.forEach(function (r) {
      var handle = extractProductHandle(r);
      if (handle) handles[handle] = true;
    });

    var uniqueHandles = Object.keys(handles);
    if (!uniqueHandles.length) return Promise.resolve({});

    return Promise.all(
      uniqueHandles.map(function (h) {
        return fetchProductData(h).then(function (data) {
          return { handle: h, data: data };
        });
      })
    ).then(function (results) {
      var map = {};
      results.forEach(function (r) {
        if (r.data) map[r.handle] = r.data;
      });
      return map;
    });
  }

  function extractProductHandle(review) {
    if (review.productHandle) return review.productHandle;
    var url = review.productUrl || review.product_url || "";
    if (url) {
      var match = url.match(/\/products\/([^/?#]+)/);
      if (match) return match[1];
    }
    if (review.productName || review.product) {
      return (review.productName || review.product)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
    }
    return "";
  }

  // ─── Okendo API ───
  function requestJson(url) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            resolve(JSON.parse(xhr.responseText));
          } catch (e) {
            reject(new Error("Invalid JSON"));
          }
        } else {
          reject(new Error("Okendo API error " + xhr.status));
        }
      };
      xhr.onerror = function () {
        reject(new Error("Network error"));
      };
      xhr.send();
    });
  }

  function buildReviewsUrl(userId, sortBy) {
    return (
      OKENDO_BASE +
      encodeURIComponent(userId) +
      "/reviews?limit=25&orderBy=" +
      encodeURIComponent(sortBy)
    );
  }

  function resolveNextUrl(userId, nextUrl) {
    if (!nextUrl) return "";
    if (nextUrl.indexOf("http") === 0) return nextUrl;
    return OKENDO_BASE + encodeURIComponent(userId) + nextUrl.replace(/^\//, "");
  }

  function sortReviewsLocally(reviews, sortBy) {
    var sorted = reviews.slice();
    sorted.sort(function (a, b) {
      switch (sortBy) {
        case "date asc":
          return new Date(a.dateCreated) - new Date(b.dateCreated);
        case "rating desc":
          return (b.rating || 0) - (a.rating || 0);
        case "rating asc":
          return (a.rating || 0) - (b.rating || 0);
        case "helpful desc":
          return (b.helpfulCount || 0) - (a.helpfulCount || 0);
        case "helpful asc":
          return (a.helpfulCount || 0) - (b.helpfulCount || 0);
        default:
          return new Date(b.dateCreated) - new Date(a.dateCreated);
      }
    });
    return sorted;
  }

  function fetchFilteredReviews(userId, limit, sortBy, mediaFilter, ratingFilter) {
    var matched = [];
    var apiSort = mediaFilter === "with_media" ? "has_media desc" : sortBy;
    var needClientSort = mediaFilter === "with_media" && sortBy !== "has_media desc";
    var url = buildReviewsUrl(userId, apiSort);
    var pagesFetched = 0;

    function fetchPage(pageUrl) {
      return requestJson(pageUrl).then(function (data) {
        var batch = data.reviews || data.list || [];
        var filtered = filterReviews(batch, mediaFilter, ratingFilter);
        matched = matched.concat(filtered);

        pagesFetched += 1;

        if (matched.length >= limit || pagesFetched >= MAX_FETCH_PAGES) {
          var result = needClientSort ? sortReviewsLocally(matched, sortBy) : matched;
          return result.slice(0, limit);
        }

        var nextUrl = resolveNextUrl(userId, data.nextUrl);
        if (!nextUrl) {
          var result = needClientSort ? sortReviewsLocally(matched, sortBy) : matched;
          return result.slice(0, limit);
        }

        return fetchPage(nextUrl);
      });
    }

    return fetchPage(url);
  }

  // ─── Review expand (popular) ───
  function initReviewExpand(section) {
    function collapsedHeight() {
      return window.matchMedia("(max-width: 768px)").matches ? 100 : 120;
    }

    section.querySelectorAll("[data-review-expand]").forEach(function (root) {
      var content = root.querySelector("[data-review-expand-content]");
      var toggle = root.querySelector("[data-review-expand-toggle]");
      if (!content || !toggle || root.dataset.expandReady) return;

      root.dataset.expandReady = "1";

      function measureFullHeight() {
        var prev = content.style.maxHeight;
        content.style.maxHeight = "none";
        var full = content.scrollHeight;
        content.style.maxHeight = prev;
        return full;
      }

      function setCollapsed() {
        content.style.maxHeight = collapsedHeight() + "px";
        root.classList.remove("is-open");
        toggle.textContent = "Show more";
        toggle.setAttribute("aria-expanded", "false");
      }

      function setExpanded() {
        content.style.maxHeight = content.scrollHeight + "px";
        root.classList.add("is-open");
        toggle.textContent = "Show less";
        toggle.setAttribute("aria-expanded", "true");
      }

      function syncExpandable() {
        var wasOpen = root.classList.contains("is-open");
        var expandable = measureFullHeight() > collapsedHeight() + 1;

        root.classList.toggle("is-expandable", expandable);
        toggle.hidden = !expandable;

        if (!expandable) {
          content.style.maxHeight = "none";
          root.classList.remove("is-open");
          toggle.setAttribute("aria-expanded", "false");
          return;
        }

        if (wasOpen) {
          setExpanded();
          content.style.maxHeight = "none";
        } else {
          setCollapsed();
        }
      }

      content.addEventListener("transitionend", function (event) {
        if (event.target !== content || event.propertyName !== "max-height") return;
        if (root.classList.contains("is-open")) {
          content.style.maxHeight = "none";
        }
      });

      toggle.addEventListener("click", function () {
        if (!root.classList.contains("is-expandable")) return;

        if (root.classList.contains("is-open")) {
          content.style.maxHeight = content.scrollHeight + "px";
          content.offsetHeight;
          setCollapsed();
          return;
        }
        setExpanded();
      });

      syncExpandable();
      window.addEventListener("resize", syncExpandable);
    });
  }

  // ─── Cart add (popular) ───
  function bindPopularCartButtons(section) {
    section.querySelectorAll(".reviews__product-cart").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute("data-variant-id");
        var productUrl = btn.getAttribute("data-product-url");

        if (!variantId && productUrl) {
          window.location.href = productUrl;
          return;
        }

        if (!variantId || btn.disabled) return;

        btn.disabled = true;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { openDrawer: true } }));
          })
          .catch(function () {})
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  // ─── Init section ───
  function initReviewsSection(section) {
    if (!section || section.dataset.reviewsReady === "true") return;
    if (typeof Swiper === "undefined") return;

    var userId = (section.dataset.okendoUserId || "").trim();
    var limit = parseInt(section.dataset.reviewsLimit, 10) || 10;
    var sortBy = section.dataset.reviewsSort || "date desc";
    var mediaFilter = section.dataset.reviewsMedia || "all";
    var ratingFilter = section.dataset.reviewsRating || "all";
    var starsSrc = section.dataset.starsSrc || "";
    var wrapper = section.querySelector("[data-reviews-wrapper]");
    var swiperEl = section.querySelector("[data-reviews-swiper]");
    var progressEl = section.querySelector("[data-reviews-progress]");
    var prevButtons = section.querySelectorAll("[data-reviews-prev]");
    var nextButtons = section.querySelectorAll("[data-reviews-next]");

    var isPopular = section.hasAttribute("data-reviews-popular");
    var cartIconSrc = section.dataset.cartIconSrc || "";
    var placeholderSrc = section.dataset.placeholderSrc || "";

    if (!userId || !wrapper || !swiperEl) return;

    var swiper = null;
    var scrollSyncFns = [];

    function syncScrollThumb(area, thumb, track) {
      var maxScroll = area.scrollHeight - area.clientHeight;
      if (maxScroll <= 0) {
        track.classList.remove("is-visible");
        thumb.style.transform = "translateY(0)";
        return;
      }

      track.classList.add("is-visible");

      var maxMove = Math.max(track.clientHeight - thumb.offsetHeight, 0);
      var ratio = area.scrollTop / maxScroll;
      thumb.style.transform = "translateY(" + ratio * maxMove + "px)";
    }

    function initReviewScrolls() {
      scrollSyncFns = [];

      section.querySelectorAll(".reviews__content").forEach(function (content) {
        var area = content.querySelector("[data-reviews-scroll]");
        var thumb = content.querySelector("[data-reviews-scroll-thumb]");
        var track = content.querySelector(".reviews__scroll");
        if (!area || !thumb || !track || area.dataset.scrollReady) return;

        area.dataset.scrollReady = "1";

        var startY = 0;

        var sync = function () {
          syncScrollThumb(area, thumb, track);
        };

        area.addEventListener("scroll", sync, { passive: true });

        area.addEventListener(
          "touchstart",
          function (event) {
            startY = event.touches[0].clientY;
            event.stopPropagation();
          },
          { passive: true }
        );

        area.addEventListener(
          "touchmove",
          function (event) {
            var maxScroll = area.scrollHeight - area.clientHeight;
            if (maxScroll <= 0) return;

            var currentY = event.touches[0].clientY;
            var scrollingDown = startY > currentY;
            var scrollingUp = startY < currentY;
            var atTop = area.scrollTop <= 0;
            var atBottom = area.scrollTop >= maxScroll - 1;

            if ((scrollingUp && atTop) || (scrollingDown && atBottom)) {
              return;
            }

            event.stopPropagation();
          },
          { passive: true }
        );

        scrollSyncFns.push(sync);
        sync();
      });
    }

    function updateNavState() {
      if (!swiper) return;

      var isBeginning = swiper.isBeginning;
      var isEnd = swiper.isEnd;

      prevButtons.forEach(function (btn) {
        btn.disabled = isBeginning;
        btn.classList.toggle("swiper-button-disabled", isBeginning);
      });

      nextButtons.forEach(function (btn) {
        btn.disabled = isEnd;
        btn.classList.toggle("swiper-button-disabled", isEnd);
      });
    }

    function bindNav() {
      prevButtons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (swiper) swiper.slidePrev();
        });
      });

      nextButtons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (swiper) swiper.slideNext();
        });
      });
    }

    function initSwiper() {
      var spaceMobile = isPopular ? 12 : 14;
      var spaceDesktop = isPopular ? 12 : 20;

      swiper = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: spaceMobile,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: progressEl,
          type: "progressbar",
        },
        breakpoints: {
          769: {
            spaceBetween: spaceDesktop,
          },
        },
      });

      swiper.on("slideChange", updateNavState);
      swiper.on("reachBeginning", updateNavState);
      swiper.on("reachEnd", updateNavState);
      swiper.on("fromEdge", updateNavState);
      swiper.on("resize", function () {
        scrollSyncFns.forEach(function (fn) {
          fn();
        });
      });

      updateNavState();

      if (!isPopular) {
        initReviewScrolls();
      }
    }

    bindNav();

    fetchFilteredReviews(userId, limit, sortBy, mediaFilter, ratingFilter)
      .then(function (reviews) {
        if (!reviews.length) {
          section.hidden = true;
          return;
        }

        if (isPopular) {
          return fetchAllProductData(reviews).then(function (productMap) {
            var html = "";
            reviews.forEach(function (review) {
              var handle = extractProductHandle(review);
              var pData = handle ? productMap[handle] : null;
              html += renderPopularSlide(review, starsSrc, cartIconSrc, pData, placeholderSrc);
            });

            wrapper.innerHTML = html;
            section.dataset.reviewsReady = "true";
            initSwiper();
            initReviewExpand(section);
            bindPopularCartButtons(section);
          });
        }

        var html = "";
        reviews.forEach(function (review) {
          html += renderSlide(review, starsSrc, placeholderSrc);
        });

        wrapper.innerHTML = html;
        section.dataset.reviewsReady = "true";
        initSwiper();
      })
      .catch(function () {
        section.hidden = true;
      });
  }

  document.querySelectorAll("[data-reviews]").forEach(initReviewsSection);
})();
